import axios from "axios";
import { notConnectedMessage } from "../../components/constants";
import { BASE_API } from "../../utils/constants";
import { Api_Response, PATCH, POST } from "../base-services";

export type Create_Api_Key_Payload = {
    masterKey: string;
    orgCode: string;
    name: string;
};

export class Api_Key_Service {
    static url = "/key";

    static async create_api_key(payload: Create_Api_Key_Payload) {
        return POST<Create_Api_Key_Response>(
            `${this.url}`,
            payload,
            {},
            {
                "x-org": payload.orgCode,
            }
        );
    }

    static async getApiKeys({ page = 1, limit = 10000, filter = {} }) {
        try {
            const response = await axios.get(
                `${BASE_API}` + Api_Key_Service.url,
                {
                    withCredentials: true,
                    params: {
                        page,
                        limit,
                        ...filter,
                    },
                }
            );
            return [response.data, null];
        } catch (err: any) {
            return [null, err?.response?.data?.message || notConnectedMessage];
        }
    }

    static async deleteApiKey(key: any) {
        try {
            console.log(key, "id");
            const response = await axios.delete(
                `${BASE_API}` + Api_Key_Service.url,
                {
                    withCredentials: true,
                    params: {
                        key: key,
                    },
                }
            );

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async edit_apiKey(key: string, changes: any, orgCode: string) {
        const response = await PATCH<any[]>(
            "/key",
            changes,
            {
                key: key,
            },

            {
                "x-org": orgCode,
            }
        );

        return response;
    }
}

type Create_Api_Key_Response = Api_Response<{
    success: boolean;
    message: string;
}>;
